/* Sisters Moto: tire size decoder for the tire size guide (sections/sm-tire-guide.liquid).
   Explains a size as it's typed and links to the tire finder with ?size=. */
(function () {
  var root = document.querySelector('[data-tg-decoder]');
  if (!root) return;
  var input = root.querySelector('[data-tg-input]');
  var out = root.querySelector('[data-tg-out]');
  var finder = root.closest('[data-finder]').getAttribute('data-finder');

  var SPEED = { J: 62, K: 68, L: 75, M: 81, N: 87, P: 93, Q: 99, R: 106, S: 112, T: 118, U: 124, H: 130, V: 149, W: 168, Y: 186 };
  var ALPHA = { H: 80, J: 90, M: 100, N: 110, P: 120, R: 120, T: 130, U: 140, V: 150 };
  var CONS = { '': 'Bias-ply (the dash)', '-': 'Bias-ply (the dash)', R: 'Radial', B: 'Bias-belted', ZR: 'Radial, rated over 149 mph' };

  // Load index -> kg (ISO table), for 40-90.
  var LOAD = [140, 145, 150, 155, 160, 165, 170, 175, 180, 185, 190, 195, 200, 206, 212, 218, 224, 230, 236, 243, 250, 257, 265, 272, 280, 290, 300, 307, 315, 325, 335, 345, 355, 365, 375, 387, 400, 412, 425, 437, 450, 462, 475, 487, 500, 515, 530, 545, 560, 580, 600];
  function load(li) {
    var kg = LOAD[li - 40];
    return kg ? li + ': up to ' + Math.round(kg * 2.2046) + ' lb (' + kg + ' kg) per tire' : '';
  }
  function speed(l) { return SPEED[l] ? l + ': up to ' + SPEED[l] + ' mph' : ''; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function tail(rest, rows) {
    var m = /^\s*(\d{2,3})\s*([A-Z])\b/.exec(rest);
    if (m) {
      var l = load(+m[1]); if (l) rows.push(['Load index', l]);
      var s = speed(m[2]); if (s) rows.push(['Speed rating', s]);
    }
    if (/\bTL\b/.test(rest)) rows.push(['Type', 'Tubeless']);
    if (/\bTT\b/.test(rest)) rows.push(['Type', 'Tube type']);
  }

  function decode(raw) {
    var q = raw.toUpperCase().replace(/\s+/g, ' ').trim();
    var m, rows = [], size = '';
    if ((m = /(\d{2,3})\s*\/\s*(\d{2,3})\s*(ZR|R|B|-)?\s*-?\s*(\d{1,2})(.*)$/.exec(q))) {
      var w = +m[1], a = +m[2], r = m[4];
      size = w + '/' + a + '-' + r;
      rows.push(['Width', w + ' mm']);
      rows.push(['Aspect ratio', a + '%, so a sidewall about ' + Math.round(w * a / 100) + ' mm tall']);
      rows.push(['Construction', CONS[m[3] || ''] || CONS['']]);
      rows.push(['Rim', r + ' inches']);
      tail(m[5], rows);
    } else if ((m = /M([HJMNPRTUV])\s*(85|90)\s*-?\s*(\d{2})(.*)$/.exec(q))) {
      var mw = ALPHA[m[1]], ma = m[2] === '85' ? 80 : 90;
      size = 'M' + m[1] + m[2] + '-' + m[3];
      rows.push(['Letter size', size + ' (M = motorcycle)']);
      rows.push(['Closest metric', mw + '/' + ma + '-' + m[3]]);
      rows.push(['Rim', m[3] + ' inches']);
      tail(m[4], rows);
    } else if ((m = /(\d{2})\s*X\s*(\d{1,2}(?:\.\d{1,2})?)\s*(?:-|R)\s*(\d{1,2})/.exec(q))) {
      size = m[1] + 'x' + m[2] + '-' + m[3];
      rows.push(['Overall height', m[1] + ' inches']);
      rows.push(['Width', m[2] + ' inches']);
      rows.push(['Rim', m[3] + ' inches']);
      rows.push(['Used on', 'ATV, UTV and flotation tires']);
    } else if ((m = /(\d\.\d{2})\s*(?:-|\s)\s*(\d{2})(.*)$/.exec(q))) {
      var iw = parseFloat(m[1]);
      size = m[1] + '-' + m[2];
      rows.push(['Width', m[1] + ' inches, about ' + Math.round(iw * 25.4) + ' mm']);
      rows.push(['Rim', m[2] + ' inches']);
      rows.push(['Note', 'Inch sizes don’t state a sidewall height']);
      tail(m[3], rows);
    }
    return { rows: rows, size: size };
  }

  function render() {
    var v = input.value.trim();
    if (!v) { out.hidden = true; out.innerHTML = ''; return; }
    var d = decode(v);
    if (!d.rows.length) {
      out.innerHTML = '<p>Keep typing: we read sizes like 110/90-19, 80/100-21, MT90-16 or 3.00-21.</p>';
    } else {
      out.innerHTML = '<dl>' + d.rows.map(function (r) { return '<dt>' + esc(r[0]) + '</dt><dd>' + esc(r[1]) + '</dd>'; }).join('') + '</dl>' +
        '<a class="sm-tg__out-link" href="' + esc(finder + '&size=' + encodeURIComponent(d.size)) + '">See tires in ' + esc(d.size) + ' →</a>';
    }
    out.hidden = false;
  }

  input.addEventListener('input', render);
  root.querySelectorAll('[data-tg-try]').forEach(function (b) {
    b.addEventListener('click', function () { input.value = b.getAttribute('data-tg-try'); render(); input.focus(); });
  });
  if (input.value) render();
})();
